module.exports = __webpack_public_path__ + "static/img/service2.d36bb568.png";